import { LocationDetails } from "./components";

export function mapLocationsData(data, questionnaireId, structure) {
  return data.map(el => {
    return {
      id: el.id,
      name: el.locationName,
      data: {
        ...el,
        questionnaireId,
        structure
      },
      component: LocationDetails,
      customTabListTitle: el.locationName,
      customTabListSubTitle: null,
      customTabPanelTitle: null
    };
  });
}

export const DATA_CALCULATION_METHODS = Object.freeze({
  "EPD": "epd",
  "DIRECT_DATA_COLLECTION": "directDataCollection"
});